import React from "react";
import styled from "styled-components";
// import PropTypes from "prop-types";

import PaymentSchedule from "../../../components/PaymentSchedule";
import BaggageFeesDisclaimer from "./BaggageFeesDisclaimer";
import ChargesSummaryTable from "../../../components/ChargesSummaryTable";
import DueToday from "./DueToday";
import { formatMoney } from "../../../util";

// Styled components
const Wrapper = styled.div`
  font-size: 14px;
`;
const FlightCancelableBanner = styled.div`
  text-align: center;
  padding: 10px;
  border-radius: 2px;
  font-weight: bold;
  background-color: rgb(197, 243, 196);
  color: rgb(8, 125, 0);
`;

const ChargesSummary = ({
  fwdlookFees,
  fareRules,
  // ppnTotalFarePerTicket,
  ppnFees,
  ppnTaxesAndFees,
  ppnBaseFare,
  numberOfETickets,
  installmentDates,
  installmentPayment,
  totalCost,
  downPayment
}) => (
  <React.Fragment>
    <h3> Charges Summary </h3>
    {/* <div class="content"> */}
    <Wrapper>
      <hr />
      <ChargesSummaryTable
        {...{
          numberOfETickets,
          ppnTaxesAndFees: formatMoney(ppnTaxesAndFees),
          ppnBaseFare: formatMoney(ppnBaseFare),
          ppnFees: formatMoney(ppnFees),
          totalCost: formatMoney(totalCost),
          fwdlookFees: formatMoney(fwdlookFees)
        }}
      />
      <PaymentSchedule
        installmentDates={installmentDates}
        installment={formatMoney(installmentPayment)}
        totalCost={formatMoney(totalCost)}
      />
      <BaggageFeesDisclaimer fareRules={fareRules} />
      <hr />
      <DueToday downPayment={formatMoney(downPayment)} />
      <hr />
      <FlightCancelableBanner>
        Every flight is cancelable within 24 hours.
      </FlightCancelableBanner>
    </Wrapper>
  </React.Fragment>
);

// ChargesSummary.propTypes = {};

export default ChargesSummary;



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/ChargesSummary/index.js